import Avatar from '@classify/react-core-components/Avatar';

interface Props {
  user: {
    displayableName: string;
    id: string | number;
    profilePicture: string;
  };
  isSmaller: boolean;
}

export default function MemberAvatar({ isSmaller, user }: Props) {
  return (
    <Avatar
      userName={user.displayableName}
      userId={user.id}
      src={user.profilePicture}
      size={isSmaller ? 'xs' : 's'}
    />
  );
}
